import { render, staticRenderFns } from "./PreRegisterSection.vue?vue&type=template&id=f5284dd0&scoped=true"
import script from "./PreRegisterSection.vue?vue&type=script&lang=js"
export * from "./PreRegisterSection.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterSection.vue?vue&type=style&index=0&id=f5284dd0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5284dd0",
  null
  
)

export default component.exports